import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { RegionDto } from "../models/region-dto";
import { RegionListDto } from "../models/region-list-dto";
import { environment } from "src/environments/environment";
import { map, tap } from 'rxjs/operators';
import { WordDto } from "../models/word-dto";
import { WordListDto } from "../models/word-list-dto";
import { ExpeditionDto } from "../models/expedition-dto";
import { ExpeditionListDto } from "../models/expedition-list-dto";
import { ExcavationDto } from "../models/excavation-dto";
import { ExcavationListDto } from "../models/excavation-list-dto";
import { SurveyDto, SurveyListDto } from "../models/survey-dto";
import { LicenseDto } from "../models/license-dto";
import { LicenseListDto } from "../models/licenses-list-dto";
import { TreeDto } from "../models/tree-dto";
import { EntityTypeDto } from "../models/entity-type-dto";
import { EntityTypeListDto } from "../models/entity-type-list-dto copy";
import { AreaListDto } from "../models/area-list-dto";
import { HachrazaMiniListDto } from "../models/hachraza-mini-list-dto";
import { LocusDetailsDto } from "../models/locus-details-dto";
import { ObjectDto } from "../models/object-dto";
import { ENTITIES_LOCI_URL, ENTITIES_URL,DECISIONS_URL, ENTITY_TYPE_URL, EXPEDITIONS_URL, EXCAVATIONS_URL, SURVEYS_URL, HACHRAZOT_URL, FIND_TYPE_URL, LICENSES_URL, HACHRAZA_DETAILS_URL, LOCUS_DETAILS_URL, MATERIAL_URL, PERIODS_URL, REGIONS_URL,SETTLEMENT_URL, SEARCH_URL, THESAURUS_URL, UNIFIED_MODULES_URL, ARCHIVE_URL, ARCHIVE_FOLDER_URL, CONSERVATION_ARCHIVE_URL, CONSERVATION_ARCHIVE_FOLDER_URL, PERSONS_URL,DECISION_LETTERS_URL, LANGUAGE_CONFIG_URL,DANA_PDF_URL, MANUSCRIPT_DETAILS_URL, THESAURUS_ALL_URL, HERITAGE_SITES_URL, ID_URL, MEDIA_VIEW_URL } from "../constants";
import { UniqueIdResolveDTO } from "../models/unique-id-resolve-dto";
import { ThesaurusTreeAllDto, ThesaurusTreeCategoryDto, TreeNodeDto } from "../models/tree-node-dto";
import { HachrazaMiniDto } from "../models/hachraza-mini-dto";
import { HachrazaDto } from "../models/hachraza-dto";
import { ModulesResponse } from "../models/modules-response-dto";
import { ScientificArchiveDocumentDto } from "../models/scientific-archive-document-dto";
import { ScientificArchiveFolderDto } from "../models/scientific-archive-folder.model";
import { AuthService } from "./auth.service";
import { PersonDto, PersonListDto } from "../models/person-dto";
import { LanguageConfigDTO } from "../models/language-config-dto";
import { BehaviorSubject } from "rxjs";
import { SettlementDto, SettlementListDto } from "../models/settlement";
import { FragmentDto } from "../models/fragment-dto";
import { ManuscriptDto } from "../models/manuscript-details-dto";
import { ImageDto } from "../models/image-dto";
import { ExcavationPageDto } from "../models/excavation-page-dto";
import { SurveyPageDto } from "../models/survey-page-dto";
import { ModelPageDto } from "../models/model-page-dto";
import { PlasterSampleDto } from "../models/plaster-sample-dto";
import { CoinDto } from "../models/coin-dto";
import { HbSectionDto } from "../models/hb-section-dto";


const httpHeaders = new HttpHeaders({
  'Content-Type': 'application/json',
  'Access-Control-Allow-Methods': 'GET, POST, PUT, OPTIONS',
  'Access-Control-Allow-Origin': environment.backendUrl,
});

@Injectable({
  providedIn: 'root'
})

export class ApiService {
  constructor(
    private http: HttpClient, 
    private authservice: AuthService
  ) { }
  private request<T>(method: string, url: string, body?: any, params?: any): Observable<T> {
    const options = {
      headers: httpHeaders,
      body,
      params
    };
    return this.http.request<T>(method, url, options);
  }

  getModuleDetails(): Observable<ModulesResponse> {
    return this.request<ModulesResponse>('GET', UNIFIED_MODULES_URL);
  }
  getLanguageConfig(): Observable<LanguageConfigDTO> {
    return this.request<LanguageConfigDTO>('GET', LANGUAGE_CONFIG_URL);
  }

  getRegions(): Observable<RegionDto[]> {
    return this.request<RegionListDto>('GET', REGIONS_URL)
      .pipe(map((regions: RegionListDto) => regions.regions));
  }
  getSettlements(): Observable<SettlementDto[]> {
    return this.request<SettlementListDto>('GET', SETTLEMENT_URL)
    .pipe(map((settlements: SettlementListDto) => settlements.settlements));
  }
  getPersons(): Observable<PersonDto[]> {
    return this.request<PersonListDto>('GET', PERSONS_URL)
      .pipe(map((persons: PersonListDto) => persons.persons));
  }

  getThesaurus(prefix: string = ""): Observable<WordDto[]> {
    return this.request<WordListDto>('GET', THESAURUS_URL, null, { prefix })
      .pipe(map((wordlist: WordListDto) => wordlist.words));
  }

  getExpeditions(prefix: string = ""): Observable<ExpeditionDto[]> {
    return this.request<ExpeditionListDto>('GET', EXPEDITIONS_URL, null, { prefix })
      .pipe(
        map((expeditions: ExpeditionListDto) => expeditions.expeditions));
  }

  getExcavations(prefix: string = ""): Observable<ExcavationDto[]> {
    return this.request<ExcavationListDto>('GET', EXCAVATIONS_URL, null, { prefix })
      .pipe(
        map((excavations: ExcavationListDto) => excavations.excavations));
  }

  getSurveys(prefix: string = ""): Observable<SurveyDto[]> {
    return this.request<SurveyListDto>('GET', SURVEYS_URL, null, { prefix })
      .pipe(
        map((surveys: SurveyListDto) => surveys.surveys));
  }

  getHachrazot(prefix: string = ""): Observable<HachrazaMiniDto[]> {
    return this.request<HachrazaMiniListDto>('GET', HACHRAZOT_URL, null, { prefix })
      .pipe(
        map((hachrazot: HachrazaMiniListDto) => hachrazot.hachrazot));
  }

  getLicenses(prefix: string = ""): Observable<LicenseDto[]> {
    return this.request<LicenseListDto>('GET', LICENSES_URL, null, { prefix })
      .pipe(map((licenses: LicenseListDto) => licenses.licenses));
  }

  getPeriods(prefix: string = ""): Observable<TreeNodeDto> {
    return this.request<TreeDto>('GET', PERIODS_URL, null, { prefix })
      .pipe(map((periods: TreeDto) => periods.root));
  }

  getFindTypes(prefix: string = ""): Observable<TreeNodeDto> {
    return this.request<TreeDto>('GET', FIND_TYPE_URL, null, { prefix })
      .pipe(map((findTypes: TreeDto) => findTypes.root));
  }

  getThesaurusAll(prefix: string = ""): Observable<ThesaurusTreeAllDto> {
    return this.request<ThesaurusTreeAllDto>('GET', THESAURUS_ALL_URL, null, { prefix })
      .pipe(map((result: ThesaurusTreeAllDto) => result));
  }

  getMaterials(prefix: string = ""): Observable<TreeNodeDto> {
    return this.request<TreeDto>('GET', MATERIAL_URL, null, { prefix })
      .pipe(map((materials: TreeDto) => materials.root));
  }

  getHeritageSites(): Observable<TreeNodeDto> {
    return this.request<TreeDto>('GET', HERITAGE_SITES_URL)
      .pipe(map((result: TreeDto) => result.root));
  }

  getEntityTypes(): Observable<EntityTypeDto[]> {
    return this.request<EntityTypeListDto>('GET', ENTITY_TYPE_URL)
      .pipe(map((entityTypes: EntityTypeListDto) => entityTypes.entityTypes));
  }


  getAreas(entityId: number): Observable<AreaListDto> {
    return this.request<AreaListDto>('GET', ENTITIES_LOCI_URL + '/' + entityId + '/areas');
  }

  getLocusDetails(entityId: number, entityType: string): Observable<LocusDetailsDto> {
    return this.request<LocusDetailsDto>('GET', LOCUS_DETAILS_URL + '/' + entityId, null, { entityType });
  }

  getObjectDetails(entityId: number) {
    return this.request<ObjectDto>('GET', ENTITIES_URL + '/' + entityId + '/object');
  }
  getCoinDetails(entityId: number) {
    return this.request<CoinDto>('GET', ENTITIES_URL + '/' + entityId + '/coin');
  }

  getPlasterSampleDetails(entityId: number): Observable<PlasterSampleDto> {
    return this.request<PlasterSampleDto>('GET', ENTITIES_URL + '/' + entityId + '/plaster-sample');
  }
  getHbSectionDetails(entityId: number): Observable<HbSectionDto> {
    return this.request<HbSectionDto>('GET', ENTITIES_URL + '/' + entityId + '/hb-section');
  }
  getFragmentDetails(entityId: number) {
    return this.request<FragmentDto>('GET', ENTITIES_URL + '/' + entityId +
      '/fragment');
    }
  getHachrazaDetails(entityId: number) {
    return this.request<HachrazaDto>('GET', HACHRAZA_DETAILS_URL + '/' + entityId);
  }
  getManuscriptDetails(entityId: number): Observable<ManuscriptDto> {
    return this.request<ManuscriptDto>('GET', MANUSCRIPT_DETAILS_URL + '/' + entityId);
  }
  
  getSurveyPage(entityId: number): Observable<SurveyPageDto> {
    return this.request<SurveyPageDto>('GET', environment.backendUrl + '/api/SurveyPage/' + entityId);
  }
  
  getExcavationPage(entityId: number): Observable<ExcavationPageDto> {
    return this.request<ExcavationPageDto>('GET', environment.backendUrl + '/api/ExcavationPage/' + entityId);
  }

  getModelPage(entityId: number): Observable<ModelPageDto> {
    return this.request<ModelPageDto>('GET', environment.backendUrl + '/api/ModelPage/' + entityId);
  }
  
  getBucketImages(origin_id: string,source:string): Observable<ImageDto[]> {
    if (source == 'dana_pdf'){
    return this.request<ImageDto[]>('GET', DANA_PDF_URL +  '/bucket-images/' + origin_id );
    }
    else if (source == 'decision_letters'){
    return this.request<ImageDto[]>('GET', DECISION_LETTERS_URL +  '/bucket-images/' + origin_id );

    }
     else {
    throw new Error(`Unknown source: ${source}`);
  }

  }
    getMediaViewUrl(modelId: string): Observable<{ url: string }> {
    return this.request<{ url: string }>('GET', `${MEDIA_VIEW_URL}/${modelId}`);
  }

  searchEntities(params: any): Observable<any> {
    return this.request<any>('POST', SEARCH_URL, params);
  }

  getArchive(entityId: number) {
    return this.request<ScientificArchiveDocumentDto>('GET', ARCHIVE_URL + '/' + entityId);
  }

  getArchiveFolder(entityId: number) {
    return this.request<ScientificArchiveFolderDto>('GET', ARCHIVE_FOLDER_URL + '/' + entityId);
  }

  getConservationArchive(entityId: number) {
    return this.request<any>('GET', CONSERVATION_ARCHIVE_URL + '/' + entityId);
  }

  getConservationArchiveFolder(entityId: number) {
    return this.request<any>('GET', CONSERVATION_ARCHIVE_FOLDER_URL + '/' + entityId);
  }

  resolveUniqueId(uniqueId: string): Observable<UniqueIdResolveDTO> {
    return this.request<UniqueIdResolveDTO>('GET', `${ID_URL}/${uniqueId}`);
  }

  getUniqueUriByEntityId(entityId: number): Observable<string> {
    return this.request<string>('GET', `${ID_URL}/entity/${entityId}`);
  }

}